export default __webpack_public_path__ + "img/bAccbWnZ.2b008035.svg";